export function last4Digits (value) {
  return value.substr(value.length - 4);
}

export function maskedLast4Digits (value) {
  let last4 = value.substr(value.length - 4),
      asterisksCount = value.length - last4.length,
      asterisks = new Array(asterisksCount + 1).join('*');
  return asterisks + last4;
}